/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { CSSObject, forBrands, Theme } from '@core-ui/react-stitch';
import { withLocalize } from '@core-ui/localization-provider';
import {
  getActiveStyleGroups,
  selectSizeForStyleGroup,
  selectSizeVariant,
} from './helpers';
import VariantButton from './components/VariantButton';
import Style from './components/Style';
import SizeContainer from './components/SizeContainer';
import { SIZE_FACET_TITLE } from './localization-tokens';
import {
  SizeFacetProps,
  SizeFacetState,
} from './types';
import { Size, SizeVariant, StyleGroup } from '../../../types';

const stylesStyle = (): CSSObject => ({
  paddingTop: 0,
});

const getSpacingStyle = (isBRRedesignEnabled: boolean): CSSObject => ({
  padding: isBRRedesignEnabled ? '0.25rem 0 0.5rem' : '0 0 0.5rem',
  top: isBRRedesignEnabled ? '3rem' : 0,
});

const variantsStyle = (theme: Theme, isBRRedesignEnabled: boolean): CSSObject => ({
  background: isBRRedesignEnabled ? theme.color.inverse?.b1 : 'white',
  boxSizing: 'border-box',
  display: 'flex',
  flexWrap: 'wrap',
  position: 'sticky',
  width: '100%',
  zIndex: '100',
  margin: 0,
  border: 'none',
  minWidth: 0,
  ...getSpacingStyle(!!isBRRedesignEnabled),
  // @ts-ignore
  ...forBrands(theme, {
    // @ts-ignore
    on: t => ({
      borderBottom: `1px solid ${t.color.g4}`,
      marginBottom: '1.5rem',
      justifyContent: 'space-around',
    }),
  }),
});

const legendStyle = (): CSSObject => ({
  opacity: 0,
  height: 0,
});

class SizeFacet extends Component<SizeFacetProps, SizeFacetState> {
  constructor(props: SizeFacetProps) {
    super(props);

    const {
      sizeVariants,
    } = props;

    // eslint-disable-next-line react/state-in-constructor
    this.state = {
      sizeVariants,
      // @ts-ignore
      activeVariant: sizeVariants[0]?.name ?? null,
      styleGroups: getActiveStyleGroups(sizeVariants),
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange();
  }



  static getDerivedStateFromProps(props: SizeFacetProps, state: SizeFacetState) {
    const getAppliedVariant = (hasVariant: any, variant: any) => hasVariant && state.activeVariant === variant.name;
  
    const getSelected  = (hasVariant: any, variant: any, index: number) => {
      const hasAppliedVariant = getAppliedVariant(hasVariant, variant);
      const shouldApplyFirstVariant = !hasVariant && index === 0;
      const selected = hasAppliedVariant || shouldApplyFirstVariant;
      return selected;
    };
   
    if (state.activeVariant) {
      // @ts-ignore
      const hasVariant = props.sizeVariants.some(
        ({ name }) => name === state.activeVariant);

      // @ts-ignore
      const variants = props.sizeVariants.map((variant, index: number) => {
        const selected = getSelected(hasVariant, variant,  index);
        return { ...variant, selected };
      });

      return {
        sizeVariants: variants,
        styleGroups: getActiveStyleGroups(variants),
        activeVariant: variants.find(({ selected }) => selected)?.name,
      };
    }
    return null;
  }

  onSizeSelected = (size: Size, styleGroup: StyleGroup) => {
    const styleGroups = selectSizeForStyleGroup(
      styleGroup,
      size,
      this.state.styleGroups,
    );

    this.setState(prevState => ({
      sizeVariants: prevState.sizeVariants,
      styleGroups,
    }));
  };

  onVariantSelected = (selectedVariant: SizeVariant) => {
    const sizeVariants = selectSizeVariant(
      selectedVariant,
      this.state.sizeVariants,
    );

    this.setState(() => ({
      sizeVariants,
      activeVariant: selectedVariant.name,
    }));

    this.props.onChange();
  };


  render = () => (
    // @ts-ignore
    <SizeContainer>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */}
      <fieldset css={theme=>variantsStyle(theme, this.props.isBRRedesignEnabled)} role='radiogroup'>
        <legend css={legendStyle}>{this.props.localize(SIZE_FACET_TITLE)}</legend>
        {/* @ts-ignore */}
        {this.state.sizeVariants.map((variant, variantKey) => (
          <VariantButton
            key={variantKey}
            applied={variant.selected}
            isBRRedesignEnabled={this.props.isBRRedesignEnabled}
            name={variant.name}
            onChange={() => this.onVariantSelected(variant)}
          />
        ))}
      </fieldset>
      <div css={stylesStyle}>
        {this.state.styleGroups.map((style, styleKey) => (
          <Style
            key={styleKey}
            isBRRedesignEnabled={this.props.isBRRedesignEnabled}
            /**
            // @ts-ignore */
            onSizeClick={this.onSizeSelected}
            style={style}
            /**
            // @ts-ignore */
            styleKey={styleKey}
            variant={this.state.activeVariant}
          />
        ))}
      </div>
    </SizeContainer>
  );
}

export default withLocalize(SizeFacet);
